import React from 'react';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';
import { useBusinessProfile } from '@/hooks/useBusinessProfile';

const BankDetailsCopyBlock = () => {
  const { businessProfile } = useBusinessProfile();
  const bd = businessProfile?.bankDetails || {};

  const rows: { label: string; value: string }[] = [
    { label: 'Account Name', value: bd.accountName || bd.account_name || businessProfile?.businessName || '' },
    { label: 'Account Number', value: bd.accountNumber || bd.account_number || '' },
    { label: 'Sort Code', value: bd.sortCode || bd.sort_code || '' },
  ];

  const copy = (label: string, value: string) => {
    if (!value) {
      toast.error(`No ${label} set in your business profile`);
      return;
    }
    navigator.clipboard.writeText(value);
    toast.success(`${label} copied`);
  };

  return (
    <div className="rounded-md border bg-muted/30 p-3 space-y-1.5">
      <p className="text-xs font-medium text-muted-foreground mb-1">
        Bank details included in the message body
      </p>
      {rows.map((row) => (
        <div key={row.label} className="flex items-center justify-between gap-2 text-sm">
          <div className="min-w-0">
            <span className="text-muted-foreground">{row.label}: </span>
            <span className="font-medium break-all">{row.value || '—'}</span>
          </div>
          <button
            type="button"
            onClick={() => copy(row.label, row.value)}
            className="inline-flex items-center gap-1 rounded-md border bg-background px-2 py-1 text-xs hover:bg-accent shrink-0"
            aria-label={`Copy ${row.label}`}
          >
            <Copy className="h-3 w-3" />
            Copy
          </button>
        </div>
      ))}
    </div>
  );
};

export default BankDetailsCopyBlock;
